import React from "react";
import { Box, Text, TextProps as ChakraTextProps } from "@chakra-ui/react";
import Tooltip from "../../../Components/Tooltip";

export interface StatColumnProps extends Omit<ChakraTextProps, "css"> {
  iconName: string;
  amount: any;
  units?: string;
  description: string;
  link?: string;
  tooltip?: string;
  msg?: string;
  headerSize?: string;
  textSize?: string;
  large?: boolean;
}

const StatColumn: React.FC<StatColumnProps> = ({
  iconName,
  amount,
  units,
  description,
  link,
  tooltip,
  msg,
  headerSize,
  textSize,
  large,
  ...textProps
}) => (
  <Box display="flex" flexDir="column">
    {/* <Center h={20} w={20}>
      {msg
          ? <ChakraTooltip label={msg} placement="top">
          
        <Icon iconName={iconName} h={20} w={20} />
      </ChakraTooltip>
      : <Icon iconName={iconName} h={20} w={20} />
      }
    </Center> */}
    <Box>
      {!link ? (
        <Text fontSize="14px" fontWeight="500" color="text-secondary">
          {description} {tooltip && <Tooltip>{tooltip}</Tooltip>}
        </Text>
      ) : (
        <Text textStyle="subheading" color="text-secondary">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={link}
            style={{ outline: "none", textDecoration: "none" }}
          >
            {description}
          </a>
        </Text>
      )}
    </Box>
    {large ? (
      <Text fontSize="24px" fontFamily="Inter" fontWeight="700">
        {amount} {units}
      </Text>
    ) : (
      <Text
        textStyle="text_lg"
        fontFamily="Inter"
        letterSpacing="tight"
        fontWeight="600"
      >
        {amount} {units}
      </Text>
    )}
  </Box>
);

export default StatColumn;
